import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import If from '../common/operador/if'


import { buscarParcelas, create, initFormCreat } from './carneAction'

class CarneFormCreat extends Component {

  componentWillMount() {
    this.setState({ ...this.state, idCliente: '' })
  }


  getDataFormatada(data) {
    let ArrDt = data.split('T')[0].split('-')
    return `${ArrDt[2]}/${ArrDt[1]}/${ArrDt[0]}`
  }

  currencyFormatter(value) {
    if (value === undefined) value = 0
    var valor = value;

    valor = valor + '';
    valor = parseInt(valor.replace(/[\D]+/g, ''));
    valor = valor + '';
    valor = valor.replace(/([0-9]{2})$/g, ",$1");

    if (valor.length > 6) {
      valor = valor.replace(/([0-9]{3}).([0-9]{2}$)/g, ".$1,$2");
    }

    return valor
  }


  renderRows() {
    const list = this.props.carne.parcelas || []
    return list.map(bc => (
      <tr key={bc.dt_vencimento}>
        <td>{this.getDataFormatada(bc.dt_vencimento)} </td>
        <td>{this.currencyFormatter(this.props.carne.cliente.valor)} </td>
        <td>{bc.num_parcela} </td>
      </tr>
    ))
  }

  submitForm(values) {
    this.setState({ ...this.state, idCliente: '' })
    this.props.create(values)
  }

  cancelForm() {
    this.setState({ ...this.state, idCliente: '' })
    this.props.initFormCreat();
  }


  render() {
    const { handleSubmit, readOnly } = this.props


    const setIdCliente = e => {
      this.setState({ ...this.state, idCliente: e.target.value });

    }

    const set12Parcela = e => {
      this.setState({ ...this.state, gerarCarneAnual: e.target.checked });
    }


    return (
      <form role='form' onSubmit={handleSubmit}>

        <div className="box-body">
          <div className="col-md-6">
            <label>Código Cliente</label>
            <div id="custom-search-input">
              <div className="input-group col-md-12">
                <span className="input-group-btn">


                </span>
                <div className="input-group col-md-12">
                  <input type="number" ref="input_id_cliente" value={this.state.idCliente} className="form-control input-sm" placeholder="Digite o ID do cliente" onChange={setIdCliente}
                    onKeyPress={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        this.props.buscarParcelas(this.state.idCliente)
                      }
                    }} />
                  <span className="input-group-btn">
                    <button className="btn btn-info btn-sm" type="button" onClick={() => this.props.buscarParcelas(this.state.idCliente, this.state.gerarCarneAnual)}>
                      <i className="glyphicon glyphicon-search"></i>&nbsp;Ver Parcelas
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6" >
            <br/>
            <span >
              <input type="checkbox" name="gerar_12_parc" id="inpt_12_parc" onClick={set12Parcela} />
            </span>
            <span data-tooltip="Se marcado essa opção sera gerada 12 parcelas a partir da próxima data de vencimento do cliente" data-tooltip-position="bottom"> &ensp;<strong>Gerar 12 parcelas</strong></span>
          </div>

          <table className="table">
            <If test={this.props.carne.parcelas.length > 0}>
              <caption>Simulação das parcelas, Cliente:  {this.props.carne.cliente.nome_cliente} -  {this.props.carne.cliente.cpf_cnpj_cliente}</caption>
              <thead>
                <tr>
                  <th>Data Vencimento</th>
                  <th>Valor</th>
                  <th>Parcela</th>
                </tr>
              </thead>
            </If>
            <tbody>
              {this.renderRows()}

            </tbody>
            <tfoot>

            </tfoot>
          </table>


        </div>
        <div className="boxfooter">
          <If test={this.props.carne.parcelas.length > 0}>
            <button type='button'
              className={`btn btn-${this.props.submitClass}`}
              onClick={() => this.submitForm(this.props.carne)}>
              <i className={`fa fa-${this.props.iconSubmit}`}></i>
              <span className='space-icon'>{this.props.submitLabel}
              </span>

            </button>
          </If>
          <button type='button' className="btn btn-default"
            onClick={() => this.cancelForm()} ><i className="fa fa-ban"></i><span className='space-icon'>Cancelar</span></button>
        </div>
      </form>
    )
  }
}

const normalizePhone = value => {
  if (!value) {
    return value
  }

  const onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length <= 3) {
    return onlyNums
  }
  if (onlyNums.length <= 7) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`
  }
  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(
    6,
    10
  )}`
}




CarneFormCreat = reduxForm({ form: 'carneFormCreat', destroyOnUnmount: false })(CarneFormCreat)
const selector = formValueSelector('carneFormCreat')
const mapStateToProps = state => ({
  //parcelas: state.carne.parcelas, cliente: state.carne.cliente,
  carne: state.carne
})

const mapDispatchToProps = dispatch => bindActionCreators({ buscarParcelas, create, initFormCreat }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(CarneFormCreat)



// WEBPACK FOOTER //
// ./src/carne/carneFormCreat.jsx